import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/info.svg';
import { Icon } from '../Icon/Icon';
export const InfoIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
